import type { ReactNode } from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/admin/coaching/coaching-dashboard/shared/tooltip'
import { MOCK_PRESETS } from '../../_mock-data/library'
import { useCoachingStore } from '../../store'

const ACTIVE_PRESET = {
  background: 'color-mix(in oklab, var(--cd-amber) 12%, transparent)',
  borderColor: 'color-mix(in oklab, var(--cd-amber) 45%, transparent)',
  color: 'var(--cd-amber)',
}

const INACTIVE_PRESET = {
  background: 'transparent',
  borderColor: 'var(--cd-border-2)',
  color: 'var(--cd-text-muted)',
}

export function PresetChips(): ReactNode {
  const { curriculum } = useCoachingStore()
  const { activePresetId, applyPreset, setFilters, setSorts, setTypeFilter } =
    curriculum

  const reset = () => {
    setFilters([])
    setSorts([])
    setTypeFilter('all')
  }

  return (
    <div className="mb-2.5 flex flex-wrap items-center gap-1.5">
      <span className="text-[9px] font-bold tracking-[.07em] text-(--cd-text-ghost)">
        PRESETS
      </span>
      {MOCK_PRESETS.map((preset) => {
        const active = activePresetId === preset.id
        return (
          <Tooltip key={preset.id}>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-pressed={active}
                onClick={() => applyPreset(preset.id)}
                className="cursor-pointer whitespace-nowrap rounded-full border px-3 py-0.5 text-[10px] font-semibold"
                style={active ? ACTIVE_PRESET : INACTIVE_PRESET}
              >
                ⚡ {preset.label}
              </button>
            </TooltipTrigger>
            <TooltipContent>{preset.description}</TooltipContent>
          </Tooltip>
        )
      })}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={reset}
            className="cursor-pointer border-0 bg-transparent px-1 py-0.5 text-[10px] text-(--cd-text-faint) hover:text-(--cd-text)"
          >
            reset
          </button>
        </TooltipTrigger>
        <TooltipContent>Clear filters, sorts, and type</TooltipContent>
      </Tooltip>
    </div>
  )
}
